import {getUserProfile, updateUserProfile, validateScreenName, createScreenName, getUserInvoiceList} from '@/libs/api/api'
import {message, loader, getImageUrl, onError, copyText, urlValidation, navigateTo, copyElement, openInNewTab} from '@/libs/helper'
import {cloneDeep, isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'

export default {
    name: 'UserForm',
    props: {},
    beforeMount() {
        this.$store.dispatch('setShowTableSettings', false)
        this.$store.dispatch('setContainer', true)
    },
    mounted() {
        this.getUserDetails()
        this.fetchInvoicesList()
    },
    components: {
        LocationForm: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/LocationForm/LocationForm.vue'), 
        ImageUpload: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/ImageUpload/ImageUpload.vue')
    },
    computed: {
        perPageSelect: {
            get(){
                return this.tableSettings.perPage
            },
            set(val){
                this.tableSettings.perPage = val
                this.pageSize = val
                this.ending_before=''
                this.starting_after = ''
                this.currentPage = 1
                this.$refs.billinghistoryTable.setLimit(val)
                // this.fetchInvoicesList()
            }
        }
    },
    data() {
        return {
            category: 'USER',
            address: {},
            user: {},
            formData: {},
            contentData: {},
            getUserData: {},
            isEmpty,
            copyText,
            getImageUrl,
            imagePreview: '',
            constants,
            activeTab: constants.PUBLISHER_TABS.SUBSCRIBER_DB,
            onError,
            userImage: {},
            navigateTo,
            validateSlug: function (rule, value, callback) {
                /* eslint-disable */
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if ((isEmpty(value)) || (value && value.length > 20) || (value && regex.test(value))) callback(new Error('Invalid screen name'))
                if (!isEmpty(value) && checkSpaces.test(value)) callback(new Error('Spaces are not allowed'))
                else callback()
            },
            columns: ['date', 'invoice_number', 'amount', 'status', 'action'],
            tableData: [],
            tableSettings: {
                headings: {
                  date: 'Date',
                  invoice_number: 'Invoice number',
                  action: 'Action',
                  amount: 'Amount',
                },
                filterable: [],
                filterByColumn: true,
                sortable: ['no'],
                perPage: '10',
                pagination: { show: true}
            },
            starting_after: '',
            ending_before: '',
            limit: 10,
            total_table_data: [],
            table_count: null,
            pageSize: '3',
            currentPage: 1,
            previousPage : 1,
        }
    },
    methods: {
        getUserDetails: async function () {
            try {
                loader(this, true)
                this.formData = await getUserProfile({user_id: this.$route.params.id})
                this.contentData = cloneDeep(this.formData)
                this.setValues(this.contentData)
                loader(this,false)
            }
            catch(error){
                console.warn('User error', error)
                loader(this, false)
            }
        },
        setValues (data) {      
            this.user = {
                first_name: data.first_name || '',
                middle_name: data.middle_name || '',
                last_name: data.last_name || '',
                email: data.email || '',
                screen_name: data.screen_name || '',
                block_after_late_payment: data.block_after_late_payment || ''
            }

            this.address = {
                line1: (data.line1 && data.line1) || '',
                line2: (data.line2 && data.line2) || '',
                city: (data.city && data.city) || '',
                postal_code: (data.postal_code && data.postal_code) || '',
                country_code: data.country_code || '',
                country_name: data.country_name || ''
            }
            
            this.userImage = {
                avatar_image: data.avatar_image || '',
                imagePreview: data.imagePreview || null,
                _id: data.id
            }

            this.imagePreview = data.avatar_image || null
            if (this.user.screen_name === '') {
                this.createMetaScreenName()
            }
        },
        updateFormData (data) {
            this.formData = data
            this.contentData = cloneDeep(this.formData)
            this.setValues(this.contentData)        
        },
        webSiteValidation: function (rule, value, callback) {
            if (isEmpty(value)) callback(new Error('Field should not be empty'))  
            if (value.includes('http')) callback(new Error('Try adding url without web protocols(http or https)'))
            if ((!value.includes('http') && !urlValidation('https://' + value))) callback(new Error('Incorrect url'))
            else callback()
        },
        submitUserName (formName) {
            this.$refs[formName].validate(async(valid) => {
                if (!valid) return
                let user = cloneDeep(this.user)
                if (this.formData.first_name !== user.first_name || this.formData.last_name !== user.last_name || this.formData.middle_name !== user.middle_name || this.formData.screen_name !== this.user.screen_name || this.formData.block_after_late_payment !== user.block_after_late_payment ) {
                    loader(this, true)
                    if (this.user.screen_name !== '') {
                        let result = await this.validateMetaScreenName()
                        if (!result.isUnique) {
                            loader(this, false)
                            message(this, constants.messageType.SUCCESS, "Screen name is already taken")
                            return
                        }
                    } 
                    let body = {
                        first_name: user.first_name,
                        middle_name: user.middle_name,
                        last_name: user.last_name,
                        user_id: this.$route.params.id,
                        screen_name: user.screen_name,
                        block_after_late_payment: user.block_after_late_payment
                    }
                    updateUserProfile(body).then(response => {
                        this.updateFormData(response)
                        message(this, constants.messageType.SUCCESS, 'Updated Successfully');
                        loader(this, false)
                    }).catch(error => {
                        console.warn(error)
                        loader(this, false)
                    })
                }
            })
            
        },
        editUserLocation (location) {
            if (this.formData.line1 !== location.line1 || this.formData.line2 !== location.line2 || this.formData.city !== location.city || this.formData.postal_code !== location.postal_code || this.formData.country_code !== location.country_code) {
                loader(this, true)
                let body = {
                    line1: location.line1,
                    line2: location.line2,
                    city: location.city,
                    postal_code: location.postal_code,
                    country_code: location.country_code,
                    user_id: this.$route.params.id,
                    country_name: location.country_name
                }
                
                updateUserProfile(body).then(response => {
                    this.updateFormData(response)
                    message(this, constants.messageType.SUCCESS, 'Updated Successfully')
                    loader(this, false)
                }).catch(error => {
                    console.warn(error)
                    loader(this, false)
                })

            }
        },
        validateField (rule, value, callback) {
            if (!isEmpty(value) && !value.match(/^[0-9a-zA-Z]+$/)) callback(new Error('Invalid characters'))  
            else callback() 
        },
        validateNumberField (rule, value, callback) {
            if (!isEmpty(value) && !value.match(/^[0-9]+$/)) callback(new Error('Invalid characters'))  
            else callback() 
        },
        disabledNameForm() {
            if (this.formData.first_name !== this.user.first_name || this.formData.last_name !== this.user.last_name || this.formData.middle_name !== this.user.middle_name || this.formData.screen_name !== this.user.screen_name || this.formData.block_after_late_payment !== this.user.block_after_late_payment) {
                return false
            }
            return true
        },
        handleCommand (command) {
            switch (command) {
                case 'COPY':
                    copyElement(this.$route.params.id)
                break
                case 'SHOW_IN_IP':
                break
            }
        },
        removeImage () {
            loader (this, true)
            let body = {
               avatar_image: '',
               user_id: this.$route.params.id
           }
           updateUserProfile(body).then(response => {
               this.updateFormData(response)
               message(this, constants.messageType.SUCCESS, 'Updated Successfully')
               loader(this, false)
           }).catch(error => {
               console.error(error)
               loader(this, false)
           })
        },

        /**
          * to validate the screen name
          */
         validateMetaScreenName: async function () {
            // body for api
            let body = {
                entity_type: this.category,
                screen_name: this.user.screen_name,
                entity_id: this.$route.params.id
            }
            // api call
            return await validateScreenName(body)
        },
        /**
         * to crete the screen name if screen name is not present
         */
        createMetaScreenName () {
            let name = (this.user.first_name && this.user.first_name.trim()) || ''
            if (this.user.last_name && this.user.last_name !== '' && this.user.last_name.trim() !== '') name = `${name} ${this.user.last_name.trim()}`
            // body for api
            let body = {
                entity_type: this.category,
                name
            }
            // api call
            createScreenName(body).then(response => {
                // assign screen name
                this.$set(this.user, 'screen_name', response.response)
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
            })
        },
        /**
             * to fetch the org invoices list
             */
         fetchInvoicesList () {
            let body = {
                entity_type:this.category,
                entity_id: this.$route.params.id,
            }
            let params = ''
            getUserInvoiceList(params, body)
            .then(response => {
                this.table_count = response.total_count
                this.tableData = response.items || []
                // this.changePage(1)
            })
            .catch(error => {
                console.error(error)
            })
        },
         /**
             * to get the date and show it in table
             * @param {*} date 
             */
          getDate (date) {
            if (date !== undefined && date !== null) {
              let d = new Date(date*1000)
              return ('0' + d.getDate()).slice(-2) + ' ' + d.toLocaleString('default', { month: 'long' })
              + ', ' + d.getFullYear()
            }
        },
        /**
         * download invoice
         */
        downloadInvoice(url) {
            openInNewTab(url)
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            this.$refs.billinghistoryTable.setPage(currentPage)
            // this.skip = (currentPage - 1) * this.selectedValue
            // this.skip = (currentPage - 1) * this.pageSize
            // call api and and set updated data
            // this.loadTableData()
        },
    },
}